import { IconButton, Popover, Typography } from "@mui/material";
import { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const CustomInfoPopover = ({ content }: { content: string }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  
    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
    const handlePopoverClose = () => setAnchorEl(null);
    return (
      <>
        <IconButton
          size="small"
          onClick={handlePopoverOpen}
          style={{
            position: "relative",
            verticalAlign: "super",
            fontSize: "0.75rem",
            color: "rgb(34, 124, 157)",
          }}
        >
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
  
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{ style: { padding: "10px", maxWidth: "300px" } }}
        >
          <Typography variant="body2" color="textPrimary">{content}</Typography>
        </Popover>
      </>
    );
  };